import React from 'react';
import SalesIndex from '../join';

export default function () {
  return <SalesIndex noFixedVideo noExitIntent ctaOverride="sales297" ctaNoTimer variant="ad" />;
}
